import React from "react";
import Translate from "../../Components/Multilanguage/Translate";

function formatDateWithSuffix(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const j = day % 10, k = day % 100;
  let suffix = 'th';
  if (j === 1 && k !== 11) suffix = 'st';
  else if (j === 2 && k !== 12) suffix = 'nd';
  else if (j === 3 && k !== 13) suffix = 'rd';
  return `${day}${suffix} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
}

function isValidImageUrlCandidate(url) {
  if (!url || typeof url !== 'string') return false;
  if (url.endsWith('/')) return false;
  if (url.startsWith('data:')) return true;
  const extMatch = url.match(/\.([a-zA-Z0-9]+)(?:\?.*)?$/);
  if (extMatch && /^(jpg|jpeg|png|gif|webp|svg|avif|bmp)$/i.test(extMatch[1])) return true;
  return false;
}

const LiveDetailsModal = ({ show, onClose }) => {
  if (!show) return null;
  const { title, originalTitle, description, start, end, thumbnail, channel } = show;
  const displayTitle = originalTitle || title;
  const startTime = formatDateWithSuffix(start);
  const endTime = formatDateWithSuffix(end);
  return (
    <div className="show-details-modal-overlay" onClick={onClose}>
      <div className="show-details-modal" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        <div className="show-details-header">
          {channel?.logo && <img src={channel.logo} alt={channel.channel_name} className="show-details-logo" />}
          <div>
            <h2>{channel?.channel_name}</h2>
            <p>{channel?.description}</p>
          </div>
        </div>
        <div className="show-details-body">
          {thumbnail && isValidImageUrlCandidate(thumbnail) && <img src={thumbnail} alt={displayTitle} className="show-details-thumbnail" />}
          <div className="show-details-content">
            <h3>{displayTitle}</h3>
            <p>{description}</p>
            <p><b><Translate textKey={'start'}/>: </b> {startTime}</p>
            <p><b><Translate textKey={'end'}/>: </b> {endTime}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveDetailsModal;
